import { render, staticRenderFns } from "./CitacaoEdit.vue?vue&type=template&id=58493413"
import script from "./CitacaoEdit.vue?vue&type=script&lang=js"
export * from "./CitacaoEdit.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports